import { render } from "./garantiasExpiracion.vue?vue&type=template&id=4747fc93&scoped=true"
import script from "./garantiasExpiracion.vue?vue&type=script&lang=js"
export * from "./garantiasExpiracion.vue?vue&type=script&lang=js"

import "./garantiasExpiracion.vue?vue&type=style&index=0&id=4747fc93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4747fc93"]])

export default __exports__